// extracted by mini-css-extract-plugin
export var card = "Card-module--card---ehP1";
export var overlay = "Card-module--overlay--x1q2L";
export var wrapper = "Card-module--wrapper--Wpo8L";
export var cardHeading = "Card-module--cardHeading--8pWun";